module.exports = Promise.all([import("utils/translator"), import("angular")]).then(deps => {
    let [Translator, angular] = deps;

    function e(a) {
        this.a = a;
        this.c = "messages";
        this.locale = a.locale;
    }
    e.$inject = ["Translator"];
    e.prototype.trans = function(a, b, c) {
        b = b || {};
        c = c || this.c;
        return this.a.get(c + ":" + a, b);
    };
    e.prototype.transChoice = function(a, b, c, d) {
        c = c || {};
        d = d || this.c;
        return this.a.get(d + ":" + a, c, b);
    };

    function f(a) {
        this.b = a;
        this.transChoice = this.transChoice.bind(this);
    }
    f.prototype.transChoice = function(a, b, c, d) {
        return this.b.transChoice(a, b, c, d);
    };

    function g(a) {
        return new f(a).transChoice;
    }
    g.$inject = ["TranslationService"];

    function h(a) {
        this.b = a;
        this.trans = this.trans.bind(this);
    }
    h.prototype.trans = function(a, b, c) {
        return this.b.trans(a, b, c);
    };

    function k(a) {
        return new h(a).trans;
    }
    k.$inject = ["TranslationService"];

    function l(a, b) {
        this.a = a.default;
        this.d = b;
        return this.a.hasOwnProperty("get") ? this.d : this.a;
    }
    l.$inject = ["Translator", "TranslatorAdapter1x"];

    function m(a) {
        return Translator;
    }
    m.$inject = ["$window"];
    var n = angular.module("boxuk.translation.provider", []).factory("Translator", m);
    var p = angular.module("boxuk.translation.adapter1x", [n.name]).service("TranslatorAdapter1x", e);
    var q = angular.module("boxuk.translation.translator", [p.name, n.name]).service("TranslationService", l);
    var r = angular.module("boxuk.translation.transchoice", [q.name]).filter("transChoice", g);
    var s = angular.module("boxuk.translation.trans", [q.name]).filter("trans", k);
    angular.module("boxuk.translation", [s.name, r.name, q.name]);
});
